import React from 'react';
import { ToggleButton, ToggleButtonGroup, styled } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    width: '100%',
    marginTop: '10px',
    marginBottom: '10px',
    backgroundColor: '#e0e0e0', // Darker grey for high visibility against white
    borderRadius: '12px',
    padding: '4px',
    boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
    '.dark-mode &': {
        backgroundColor: '#2a2a2a', // Dark mode specific
        boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.2)',
    },
    '& .MuiToggleButtonGroup-grouped': {
        margin: '0 4px',
        border: 0,
        borderRadius: '8px !important',
        '&.Mui-disabled': {
            border: 0,
        },
        '&:not(:first-of-type)': {
            borderRadius: '8px',
        },
        '&:first-of-type': {
            borderRadius: '8px',
        },
    },
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    flex: 1,
    color: '#444', // Dark text for unselected state
    textTransform: 'none',
    padding: '8px',
    transition: 'all 0.2s ease',
    '&.Mui-selected': {
        boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
        fontWeight: 'bold',
        '&.whatsapp': {
            backgroundColor: '#25D366',
            color: '#fff',
            '&:hover': { backgroundColor: '#128C7E' },
        },
        '&.instagram': {
            background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
            color: '#fff',
        },
        '&.facebook': {
            backgroundColor: '#1877F2',
            color: '#fff',
            '&:hover': { backgroundColor: '#166fe5' },
        },
        '&.all': {
            backgroundColor: '#fff',
            color: '#000',
            '&:hover': { backgroundColor: '#f0f0f0' },
        },
    },
    '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
    },
}));

function PlatformSelector({ selectedPlatform, onPlatformChange }) {
    const handleFormat = (event, newPlatform) => {
        if (newPlatform !== null) {
            onPlatformChange(newPlatform);
        }
    };

    return (
        <div style={{ padding: '0 12px' }}>
            <StyledToggleButtonGroup
                value={selectedPlatform}
                exclusive
                onChange={handleFormat}
                aria-label="platform selector"
            >
                <StyledToggleButton value="all" className="all" title="All Chats">
                    <AllInclusiveIcon fontSize="small" />
                </StyledToggleButton>
                <StyledToggleButton value="whatsapp" className="whatsapp" title="WhatsApp">
                    <WhatsAppIcon fontSize="small" />
                </StyledToggleButton>
                <StyledToggleButton value="instagram" className="instagram" title="Instagram">
                    <InstagramIcon fontSize="small" />
                </StyledToggleButton>
                <StyledToggleButton value="facebook" className="facebook" title="Facebook">
                    <FacebookIcon fontSize="small" />
                </StyledToggleButton>
            </StyledToggleButtonGroup>
        </div>
    );
}

export default PlatformSelector;
